module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Grayzel_30.340b581e.png";